<dx-data-grid
  [visible]="visible"
  class="grid theme-dependent traitement-export-bo-grid"
  [dataSource]="traitements"
  [showBorders]="true"
  [loadPanel]="{enabled:true}"
  [allowColumnResizing]="true"
  [filterValue]="filterValue"
  [height]="height"
>
  <dxo-toolbar>
    <dxi-item location="before">
      <div *dxTemplate>
        <span class="toolbar-titre">{{ titre }}</span>
      </div>
    </dxi-item>
    <dxi-item location="after">
      <div *dxTemplate>
        <dx-button
          text="Rafraîchir"
          icon="refresh"
          (onClick)="refreshRequested.emit(true)"
          [disabled]="!manualRefreshEnabled"
          stylingMode="contained"
          type="default"
        ></dx-button>
      </div>
    </dxi-item>
  </dxo-toolbar>

  <dxo-filter-panel [visible]="showFilterPanel">
  </dxo-filter-panel>
  <dxo-paging [enabled]="showPaging" [pageSize]="pageSize"></dxo-paging>

  <dxi-column dataField="intitule" caption="Intitulé" [width]="compact ? 350 : 400"></dxi-column>
  <dxi-column dataField="etat" caption="État" [width]="100"></dxi-column>
  <dxi-column dataField="resultat" caption="Résultat" [width]="100"></dxi-column>
  <dxi-column [calculateCellValue]="extractRaisonFromMetadata" caption="Raison" [width]="400"></dxi-column>
  <dxi-column [visible]="!compact" dataField="metadata" caption="Données" cellTemplate="metadataTemplate">
    <div *dxTemplate="let data of 'metadataTemplate'">
      <textarea *ngIf="data.value" class="metadata-textarea" rows="10">{{ data.value | xml }}</textarea>
    </div>
  </dxi-column>
</dx-data-grid>
